import { Router } from 'vue-router'
import { routerConstants } from '@/constants/routers/common'
import { IQuestionsTemplateState } from '@/types/common/questions'

const { PATH } = routerConstants.LOCATION

export const useActions = (props: IQuestionsTemplateState, router: Router) => {
  const pages = [PATH.QUESTIONS_ONE, PATH.QUESTIONS_TWO, PATH.QUESTIONS_THREE, PATH.QUESTIONS_FOUR, PATH.QUESTIONS_FIVE]

  /**
   * 前のページへ戻れるか
   */
  const canPrev = (): boolean => {
    return props.pageNumber > 1
  }
  /**
   * 次のページへ進めるか
   */
  const canNext = (): boolean => {
    return props.pageNumber < pages.length && !!props.inputValue
  }
  /**
   * 前のページへ戻る
   */
  const prev = (): void => {
    if (canPrev()) {
      router.push(pages[props.pageNumber - 2])
    }
  }
  /**
   * 次のページへ進む
   */
  const next = (): void => {
    if (canNext()) {
      router.push(pages[props.pageNumber])
    }
  }

  return {
    canPrev: canPrev,
    canNext: canNext,
    prev: prev,
    next: next,
  }
}
